jQuery(document).ready(function($) {
    // Wait for 500 milliseconds after page load

      // Iterate over all elements with class "editor-content" within body with class "slug-blogs"
      $('body.slug-blogs .editor-content').each(function() {
        // Get the content of the element
        var content = $(this).html();
        
        // Replace the string
        content = content.replace(/SOOC Pepperoncini Olive Oil/g, 'SOOC Varietal Olive Oil');
        
        // Set the modified content back to the element
        $(this).html(content);
      });

  });


/*
jQuery(document).ready(function() {
    // Define a function to update the text content
    function updateShippingText() {
        var isOpen = jQuery(".cart-pullout").hasClass("open");
        var isEmptyCartHidden = !jQuery("p.empty-cart-notice.text-center").is(":visible");

        if (isOpen) {
            var currentPrice = parseFloat(jQuery(".cart-pullout--total").text().replace('$', ''));
            var threshold = 100.00;

            var difference = threshold - currentPrice;
            var shippingText;
            var progressBarWidth;

            if (difference > 0) {
                shippingText = "You're $" + difference.toFixed(2) + " away from free shipping";
                progressBarWidth = Math.min((1 - difference / threshold) * 100, 100) + "%";
            } else {
                shippingText = "Your order qualifies for free US shipping";
                progressBarWidth = "100%";
            }

            // Check if the cart is empty
            var isCartEmpty = jQuery(".cart-pullout--total").text().trim() === "";

            // Check if the "empty-cart-notice.text-center" is visible without "display: none"
            var isEmptyCartVisible = jQuery("p.empty-cart-notice.text-center").is(":visible") &&
                jQuery("p.empty-cart-notice.text-center").css("display") !== "none";

            if (isCartEmpty && isEmptyCartVisible) {
                shippingText = "You're $100.00 away from Free Shipping!";
                progressBarWidth = "100%";
            }

            jQuery(".freeshipping_bar p").text(shippingText);
            jQuery(".freeshipping_bar .progressbar").css("width", progressBarWidth);
        }
    }

    // Function to handle the initial update when an item is added to the cart
    function handleInitialUpdate() {
        updateShippingText();
    }

    // Use a MutationObserver to detect changes in the "cart-pullout" class
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (jQuery(".cart-pullout").hasClass("open")) {
                    // Perform the initial update when "cart-pullout" gets the "open" class
                    handleInitialUpdate();

                    // Set up an interval to periodically check for changes and update
                    var intervalId = setInterval(function() {
                        updateShippingText();
                    }, 500);

                    // Clear the interval when needed (for example, when the cart is closed)
                    // clearInterval(intervalId);
                }
            }
        });
    });

    // Observe changes in the target node (the "cart-pullout" element)
    observer.observe(document.querySelector('.cart-pullout'), { attributes: true, subtree: false });
});



*/






jQuery(document).ready(function($) {


    $('#gsModalContainer .gs__validate-line, #gsMultishippingPage .gs__validate-line').each(function(){
    $(this).after('<div class="mutliship-description">Are you shopping for corporate gifts to be shipped separately? Reach out to <a href="mailto:meleah@saratogaoliveoil.com">meleah@saratogaoliveoil.com</a> for corporate pricing and ease of ordering for multi-shipments.</div>');
    });



    const element = $('a[href="#corporate-wedding--buttons--1587485449133-2"]');
  
  if (element.length) {
    element.addClass('popup1').attr('href', '#popup1');
  }
    $(".popup1").click(function(){
        document.querySelector('a[href="#corporate-wedding--buttons--1587483976370-2"]').click();
    }); 




  
  const element2 = $('a[href="#corporate-wedding--buttons--1589227064387-2"]');
  
  if (element2.length) {
    element2.addClass('popup2').attr('href', '#popup2');
  }
    $(".popup2").click(function(){
        document.querySelector('a[href="#corporate-wedding--buttons--1587419549422-2"]').click();
    }); 





    const element3 = $('a[href="#corporate-wedding--buttons--d441be4f-61f2-4060-9c21-6e3c2ecde242-1"]');
  
  if (element3.length) {
    element3.addClass('popup3').attr('href', '#popup3');
  }
    $(".popup3").click(function(){
        document.querySelector('a[href="#corporate-wedding--buttons--fc418033-d059-4402-8402-fbadd432e139-1"]').click();
    }); 




    const element4 = $('a[href="#corporate-wedding--buttons--d43ad94e-f65d-47b3-ba0f-2e075968af9e-1"]');
  
  if (element4.length) {
    element4.addClass('popup4').attr('href', '#popup4');
  }
    $(".popup4").click(function(){
        document.querySelector('a[href="#corporate-wedding--buttons--7fbb6142-094b-4ebd-ad97-2ad324829879-1"]').click();
    }); 
  
  
  
});





var _learnq = _learnq || [];

// Function to check if current URL contains "/recipes/"
function logEventBasedOnURL() {
  if (window.location.href.indexOf('/recipes/') !== -1) {
    // Get the blog title from the h1 element with class "relative"
    var blogTitleElement = document.querySelector('h1.text-green.m-b-20');
    var blogTitle = blogTitleElement ? blogTitleElement.textContent.trim() : 'Unknown Title';

    // Push the event with the blog title to _learnq
    _learnq.push(["track", "Viewed Recipe", { title: blogTitle }]);
  }
}

// Run the function after 1.5 seconds
setTimeout(logEventBasedOnURL, 1500);





document.addEventListener("DOMContentLoaded", function() {
  // Delay the click action by 800ms
  setTimeout(function() {
    // Get the fragment identifier (hash) from the URL
    var hash = window.location.hash;

    // Check if the hash starts with '#vs'
    if (hash.startsWith("#vs")) {
      // Extract the number after '#vs'
      var vsValue = hash.replace("#vs", ""); 

      // Construct the selector based on the vs value
      var selector = 'label.variant-item-' + vsValue;

      // Find the element that matches the selector
      var variantLabel = document.querySelector(selector);

      // If the element exists, trigger a click event
      if (variantLabel) {
        variantLabel.click();
      }
    }
  }, 800); // 800ms delay
});




function clickGoBig(container){
  let buttons = container.querySelectorAll(".add-to-cart--button");
  if (buttons.length > 1) {
    buttons[1].click()
  }
}

function checkRechargeLoaded(container, rechargeContainer){
  if(rechargeContainer.querySelector('input')){
    clickGoBig(container)
  } else {
    setTimeout(() => checkRechargeLoaded(container, rechargeContainer), 500)
  }
}

document.querySelectorAll(".add-to-cart--go-big").forEach(container => {
  const rechargeContainer = document.querySelector('.recharge-subscription-widget')
  if(rechargeContainer){
    checkRechargeLoaded(container, rechargeContainer)
  } else {
    clickGoBig(container)
  }
})



jQuery(window).on('load', function () {
    if (window.location.pathname.includes('/products/') && window.location.hash === '#ingredients') {
        var button = jQuery('ada-toggler[type="tabs"]:nth-child(2) button');
        var buttonText = jQuery('.ingredients_tab p');

        if (button.length) {
            setTimeout(function() {
                button.trigger('click');

                if (buttonText.length) {
                    jQuery('html, body').animate({
                        scrollTop: buttonText.offset().top
                    }, 800);
                }
            }, 500); 
        }
    }
});




window.addEventListener("load", function () {
    if (window.location.href === "https://saratogaoliveoil.com/pages/wholesale#form") {
        setTimeout(() => {
            const button = document.querySelector(".corporate-wedding--buttons a:nth-child(1)");
            if (button) {
                button.click();
            }
        }, 100);
    }
});


/* ---------------------------------------------------------------------------
   Promotional pricing, display only.

   Markup comes from snippets/promo-price.liquid, which emits an empty
   .promo-prices span holding one .promo-price data node per promotion covering
   that product. Here we pick the promotion that is live right now and applies
   to the variant currently selected, strike the neighbouring price and print
   the discounted price next to it.

   The discounted price is derived from whatever price is currently on screen
   rather than from a variant table, so it keeps up with application.js
   rewriting the price when a size is selected.

   The cart and checkout are untouched -- the real reduction is a Shopify
   automatic discount.

   Set window.PROMO_DEBUG = true before load to log why a promo did not render.
   ------------------------------------------------------------------------ */
(function () {
  var WAS_CLASS = 'promo-price__was';
  var HIDDEN_CLASS = 'promo-price__hidden';
  // Containers that hold one product's price and its variant picker. On the
  // product page the price sits outside the form, so .product-details-col is
  // the only element wrapping both.
  var SCOPE = '.product-thumbnail, .product-details-col, .add-to-cart';
  // Recharge renders its widget client-side into the app block, so its markup is
  // never in the page source and there is no Liquid to render into. Its one-time
  // line is a bare text node -- "One-time Purchase $41.95" -- with no element
  // around the price, so the price has to be lifted out of the text.
  var RECHARGE_HOST = '.recharge-subscription-widget, .rc-widget-injection-parent';
  var MONEY_IN_TEXT = /\$\s?[\d,]+\.\d{2}/;
  var pending = false;

  function debug() {
    if (window.PROMO_DEBUG && window.console) {
      console.log.apply(console, ['[promo]'].concat([].slice.call(arguments)));
    }
  }

  function parseMoney(text) {
    var match = String(text).match(/^(\D*?)([\d][\d.,]*)(.*)$/);
    if (!match) return null;
    var value = parseFloat(match[2].replace(/,/g, ''));
    if (isNaN(value)) return null;
    return { cents: Math.round(value * 100), prefix: match[1], suffix: match[3] };
  }

  function formatMoney(cents, prefix, suffix) {
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return prefix + parts.join('.') + suffix;
  }

  // Which variant the shopper is looking at, as a string id.
  function currentVariantId(wrap) {
    var scope = wrap.closest(SCOPE) || document;
    // Product page: one radio per size. Scoped to the add-to-cart input class so
    // the Recharge one-time/subscribe radios can't be mistaken for a variant.
    var radio = scope.querySelector('input.add-to-cart--hidden-input:checked');
    if (radio && radio.value) return radio.value;
    // Teaser cards, and the Klaviyo-driven select on the product page.
    var select = scope.querySelector('#variant_select, select[name="id"]');
    if (select && select.value) return select.value;
    // Single-variant products render a hidden input instead of a picker.
    var hidden = scope.querySelector('input[name="id"]');
    if (hidden && hidden.value) return hidden.value;
    return null;
  }

  function coversVariant(promo, variantId) {
    var listed = (promo.dataset.variants || '').split(',').filter(Boolean);
    if (!listed.length) return true; // whole product or collection
    if (!variantId) return false;
    return listed.indexOf(String(variantId)) !== -1;
  }

  function livePromo(wrap, now, variantId) {
    var nodes = wrap.querySelectorAll('.promo-price');
    for (var i = 0; i < nodes.length; i++) {
      var start = nodes[i].dataset.start ? Number(nodes[i].dataset.start) * 1000 : -Infinity;
      var end = nodes[i].dataset.end ? Number(nodes[i].dataset.end) * 1000 : Infinity;
      if (isNaN(start) || isNaN(end)) continue;
      if (now < start || now > end) continue;
      if (!coversVariant(nodes[i], variantId)) continue;
      return nodes[i];
    }
    return null;
  }

  function salePrice(cents, promo) {
    var percent = Number(promo.dataset.percent) || 0;
    var amount = Number(promo.dataset.amount) || 0;
    if (percent > 0) return Math.max(0, Math.round((cents * (100 - percent)) / 100));
    if (amount > 0) return Math.max(0, cents - Math.round(amount * 100));
    return null;
  }

  function clear(wrap, parent, base) {
    var out = wrap.querySelector('.promo-price__now');
    if (out) out.parentNode.removeChild(out);
    if (base) base.classList.remove(WAS_CLASS);
    var compare = parent.querySelector('.compare-at-price');
    if (compare) compare.classList.remove(HIDDEN_CLASS);
  }

  // Re-run when the theme rewrites the price on variant change.
  function watch(wrap, base) {
    if (wrap.dataset.promoWatching || typeof MutationObserver === 'undefined') return;
    wrap.dataset.promoWatching = '1';
    new MutationObserver(schedule).observe(base, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function applyOne(wrap, now) {
    var parent = wrap.parentElement;
    if (!parent) return;

    var selector = wrap.dataset.target || '.add-to-cart--current-price';
    var base = parent.querySelector(selector);
    if (!base) {
      // The price is not always a direct sibling; widen to the product container.
      var scope = wrap.closest(SCOPE);
      if (scope) base = scope.querySelector(selector);
    }
    if (!base) return debug('no price element for', selector, wrap);

    watch(wrap, base);

    var variantId = currentVariantId(wrap);
    var promo = livePromo(wrap, now, variantId);
    if (!promo) return clear(wrap, parent, base);

    var parsed = parseMoney(base.textContent);
    if (!parsed) {
      debug('unparseable price', base.textContent);
      return clear(wrap, parent, base);
    }

    var sale = salePrice(parsed.cents, promo);
    if (sale === null || sale >= parsed.cents) return clear(wrap, parent, base);

    var out = wrap.querySelector('.promo-price__now');
    if (!out) {
      out = document.createElement('span');
      out.className = 'promo-price__now';
      wrap.appendChild(out);
    }
    var next = formatMoney(sale, parsed.prefix, parsed.suffix);
    // Only write on a real change: the Recharge widget is watched for mutations
    // and rewriting the same text would keep waking us up forever.
    if (out.textContent !== next) out.textContent = next;
    base.classList.add(WAS_CLASS);

    // The struck base price already reads as the "was", so a compare-at price
    // alongside it would show two crossed-out numbers.
    var compare = parent.querySelector('.compare-at-price');
    if (compare) compare.classList.add(HIDDEN_CLASS);
  }

  // The Recharge subscription widget is injected by the app after load, so there
  // is no Liquid to render into. Its one-time line shows the selected variant's
  // price, which is exactly what the main price block already carries promo data
  // for, so we clone that data across rather than duplicating the matching.
  function onetimeLabels() {
    var labels = document.querySelectorAll('.onetime-radio .rc-radio__label');
    if (labels.length) return labels;
    // Fall back to the radio's value in case the class changes.
    var found = [];
    var inputs = document.querySelectorAll('.rc-radio__input[value="onetime"]');
    for (var i = 0; i < inputs.length; i++) {
      var label = inputs[i].parentElement && inputs[i].parentElement.querySelector('.rc-radio__label');
      if (label) found.push(label);
    }
    return found;
  }

  // The label's text as Recharge wrote it, whether or not we have already pulled
  // the price out of it. Once decorated the price lives in our own <s>, so it is
  // folded back in -- but if Vue has since rewritten the text node with a fresh
  // price, that wins and the stale <s> is ignored.
  function rawLabel(label) {
    var withoutWas = '';
    var withWas = '';
    for (var i = 0; i < label.childNodes.length; i++) {
      var node = label.childNodes[i];
      var cl = node.classList;
      if (cl && cl.contains('promo-prices')) continue;
      withWas += node.textContent;
      if (cl && cl.contains(WAS_CLASS)) continue;
      withoutWas += node.textContent;
    }
    return MONEY_IN_TEXT.test(withoutWas) ? withoutWas : withWas;
  }

  // Lift `money` out of the label's text into a struck <s>, and put `sale` after
  // it. Vue owns that text node and patches it by reference on variant change, so
  // it is edited in place rather than replaced -- detaching it would leave the
  // widget writing prices into a node that is no longer on the page.
  function decorate(label, money, sale) {
    var was = label.querySelector('.' + WAS_CLASS);
    var wrap = label.querySelector('.promo-prices');

    for (var i = 0; i < label.childNodes.length; i++) {
      var node = label.childNodes[i];
      if (node.nodeType !== 3) continue;
      var at = node.nodeValue.indexOf(money);
      if (at === -1) continue;

      var after = node.nodeValue.slice(at + money.length);
      node.nodeValue = node.nodeValue.slice(0, at);
      if (!was) {
        was = document.createElement('s');
        was.className = WAS_CLASS;
      }
      was.textContent = money;
      node.parentNode.insertBefore(was, node.nextSibling);
      if (after) was.parentNode.insertBefore(document.createTextNode(after), was.nextSibling);
      break;
    }

    if (!was) return false;

    if (!wrap) {
      wrap = document.createElement('span');
      wrap.className = 'promo-prices';
      // This one holds no promo data of its own -- attachRecharge fills it -- so
      // the generic pass has to leave it alone instead of finding it empty and
      // clearing the price back out.
      wrap.setAttribute('data-promo-managed', '1');
    }
    var out = wrap.querySelector('.promo-price__now');
    if (!out) {
      out = document.createElement('span');
      out.className = 'promo-price__now';
      wrap.appendChild(out);
    }
    if (out.textContent !== sale) out.textContent = sale;
    if (label.lastChild !== wrap) label.appendChild(wrap);
    return true;
  }

  function undecorate(label, raw) {
    var was = label.querySelector('.' + WAS_CLASS);
    var wrap = label.querySelector('.promo-prices');
    if (!was && !wrap) return;
    for (var i = 0; i < label.childNodes.length; i++) {
      if (label.childNodes[i].nodeType === 3) {
        label.childNodes[i].nodeValue = raw;
        break;
      }
    }
    if (was) was.parentNode.removeChild(was);
    if (wrap) wrap.parentNode.removeChild(wrap);
  }

  function attachRecharge(now) {
    var hosts = document.querySelectorAll(RECHARGE_HOST);
    // The widget rebuilds itself when the shopper changes variant, so watch it
    // rather than assuming our markup survives.
    for (var h = 0; h < hosts.length; h++) {
      if (hosts[h].dataset.promoWatching || typeof MutationObserver === 'undefined') continue;
      hosts[h].dataset.promoWatching = '1';
      new MutationObserver(schedule).observe(hosts[h], { childList: true, subtree: true });
    }

    var labels = onetimeLabels();
    if (!labels.length) return;

    // The one-time line shows the selected variant's price, which the main price
    // block already carries promo data for, so reuse it rather than duplicating
    // the matching.
    var source = document.querySelector('.promo-prices[data-target=".add-to-cart--current-price"]');
    if (!source) return debug('widget present but no promo data to read');
    var promo = livePromo(source, now, currentVariantId(source));

    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      var raw = rawLabel(label);
      var money = raw.match(MONEY_IN_TEXT);
      var parsed = money && parseMoney(money[0]);
      var sale = promo && parsed ? salePrice(parsed.cents, promo) : null;

      if (!parsed || sale === null || sale >= parsed.cents) {
        undecorate(label, raw);
        delete label.dataset.promoSig;
        continue;
      }

      var text = formatMoney(sale, parsed.prefix, parsed.suffix);
      var sig = raw + '|' + text;
      // Nothing to do, and staying still is what keeps the observer quiet.
      if (label.dataset.promoSig === sig && label.querySelector('.promo-price__now')) continue;
      if (decorate(label, money[0], text)) label.dataset.promoSig = sig;
    }
  }

  function applyPromos(root) {
    var now = Date.now();
    if (!root) attachRecharge(now);
    var wraps = (root || document).querySelectorAll('.promo-prices');
    debug('applying to', wraps.length, 'price blocks');
    for (var i = 0; i < wraps.length; i++) {
      if (wraps[i].dataset.promoManaged) continue;
      applyOne(wraps[i], now);
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      applyPromos();
    });
  }

  window.applyPromos = applyPromos;

  document.addEventListener('DOMContentLoaded', schedule);
  // Carousels clone their slides on init, and bfcache restores can be days old.
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);

  // Picking a variant can change which promo applies even when the price text
  // itself doesn't, so the MutationObserver alone isn't enough. rAF puts us
  // after the theme's own handlers.
  function onInteraction(event) {
    if (event.target.closest && event.target.closest(SCOPE)) schedule();
  }
  document.addEventListener('change', onInteraction, true);
  document.addEventListener('click', onInteraction, true);

  // Flip a promo on or off while the page sits open.
  setInterval(schedule, 60000);
})();
